//@ts-nocheck
import { Fragment, useEffect, useState } from "react";
// import CustomSelect, { Option } from "../../../../custom_components/CustomSelect";
import useUrlParams from "../../../../hooks/useUrlParams";
import { Form } from "react-bootstrap";
import "./Console.scss";
import { toast } from "react-toastify";
import useTrueTwin from "../../../../hooks/useTrueTwin";
import { showToastMessage } from "../../../../../../utils/commonFunctions";
import { CurlyBraces } from "./ConsoleSvg";
import ModalInput from "../../../../custom_components/ModalInput";
import DualEditorForm from "./DualEditorForm";

import CustomSelect from "../../../../../CommonComponents/CustomSelect";

import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

interface BusFormProps {
  busComponentOptions: any[];
  fetchBusCommands: (components: string) => void;
  busCommandOptions: any[];
}
const BusForm: React.FC<BusFormProps> = ({ busComponentOptions, fetchBusCommands, busCommandOptions }) => {
  const { truetwin_id } = useTrueTwin();
  const { mission_name, mission_id, sat_name, sat_id, truetwin_name, dashboard, scenario_name, scenario_id } = useUrlParams();
  const [selectedBusComponent, setSelectedBusComponent] = useState<any | null>({ value: "All", label: "All" });
  const [selectedTelecommand, setSelectedTelecommand] = useState<any | null>(null);
  const [previewTelecommandData, setPreviewTeleCommandData] = useState<any>({});
  const [isValid, setIsValid] = useState<boolean>(true);
  const [isCommandDataJson, setIsCommandDataJson] = useState(true);

  const [isSelectedCommand, setIsSelectedCommand] = useState<any | null>(null);

  useEffect(() => {
    fetchBusCommands("All");
    sessionStorage.setItem("currentForm", "bus");
    window.dispatchEvent(new Event("storageUpdate"));
  }, []);

  const setBusFormData = (data) => {
    // Create the base formData object
    const formData = [
      {
        TruetwinId: truetwin_id,
        LinkId: "",
        scenarioId: scenario_id,
        Timestamp: null,
        Type: "completeJson",
        ScheduleId: "default",
        TaskId: "default",
        sequenceData: data?.sequenceData,
      },
    ];
    // Add CommandName only if dashboard is "operate"
    if (dashboard === "operate") {
      formData[0].CommandName = data?.commandName;
    }
    // Save formData to sessionStorage
    sessionStorage.setItem("formData", JSON.stringify(formData));

    return formData;
  };

  useEffect(() => {
    // session storage is synchronized with state
    sessionStorage.setItem("selectedBusComponent", JSON.stringify(selectedBusComponent));
    sessionStorage.setItem("selectedTelecommand", JSON.stringify(selectedTelecommand));
    sessionStorage.setItem("previewTelecommandData", JSON.stringify(previewTelecommandData));
    window.dispatchEvent(new Event("storageUpdate"));
  }, [selectedBusComponent, selectedTelecommand, previewTelecommandData]);

  useEffect(() => {
    const clearFormFields = () => {
      setBusFormData(JSON.parse(sessionStorage.getItem("selectedTelecommand"))?.value);
      sessionStorage.setItem("currentForm", "bus");
    };

    window.addEventListener("clearFormFields", clearFormFields);
    return () => {
      window.removeEventListener("clearFormFields", clearFormFields);
    };
  }, []);

  const handleSelectComponent = (data) => {
    setSelectedBusComponent(data);
    sessionStorage.setItem("selectedBusComponent", JSON.stringify(data));
    fetchBusCommands(data?.value);
    // Empty commands selection on changing components
    setSelectedTelecommand(null);
    setIsSelectedCommand(null);
    setPreviewTeleCommandData({});
    window.dispatchEvent(new Event("storage"));
  };

  const handleSelectCommands = (data) => {
    setSelectedTelecommand(data);
    sessionStorage.setItem("selectedTelecommand", JSON.stringify(data));
    const Teledata = {
      sequenceData: data.value.sequenceData,
      commandName: data.value.name,
      commandType: "BUS",
    };
    setPreviewTeleCommandData(Teledata);
    sessionStorage.setItem("previewTelecommandData", JSON.stringify(Teledata));
    setBusFormData(Teledata);
    window.dispatchEvent(new Event("storage"));
    setIsSelectedCommand(data);
  };

  const clearTelecommand = () => {
    if (selectedTelecommand) {
      setSelectedTelecommand(null);
    }
    if (Object?.keys(previewTelecommandData)?.length > 0) {
      setPreviewTeleCommandData({});
    }
  };

  const clearComponent = () => {
    setSelectedBusComponent(null);
    clearTelecommand();
  };

  return (
    <Fragment>
      <div className="left__panel__body__input__dropdown__container left__panel__body__input__custom__dropdown">
        <span className="input__label">Component</span>
        <CustomSelect
          options={busComponentOptions}
          value={selectedBusComponent}
          onChange={(data) => {
            handleSelectComponent(data);
          }}
          // style={{ height: '24px' }}
          fontSize={"12px"}
          top={"28px"}
          onInputChange={clearComponent}
        />
      </div>
      <div className="left__panel__body__input__dropdown__container left__panel__body__input__custom__dropdown left__panel__body_input__border">
        <span className="input__label">Commands</span>
        <CustomSelect
          options={busCommandOptions}
          value={selectedTelecommand}
          placeholder="Telecommands"
          onChange={(data) => {
            handleSelectCommands(data);
          }}
          // customToolTipRequired={true}
          // customToolTipPlacement={"top"}
          // style={{ height: '24px' }}
          // fontSize={"12px"}
          // top={"28px"}
          onInputChange={clearTelecommand}
          disabled={!selectedBusComponent}
          isSearchable={true}
          id="commands-dropdown"
        />
        <ReactTooltip anchorSelect="#commands-dropdown" place="bottom">
          {isSelectedCommand?.label}
        </ReactTooltip>
      </div>

      <DualEditorForm
        jsonData={previewTelecommandData}
        setPreviewTeleCommandData={setPreviewTeleCommandData}
        setBusFormData={setBusFormData}
        selectedTelecommand={selectedTelecommand}
      />
    </Fragment>
  );
};

export default BusForm;
